import { mainColor, UNIT } from '../../constants';

export const styles = () => ({
  fab: {
    backgroundColor: `rgba(${mainColor.red}, ${mainColor.green}, ${mainColor.blue}, 0.8)`,
    '&:hover': {
      backgroundColor: `rgba(${mainColor.red}, ${mainColor.green}, ${mainColor.blue}, 1)`
    }
  },
  icon: {
    fontSize: UNIT * 1.5,
    color: mainColor.colorRed
  },
  progress: {
    margin: UNIT * 5,
    textAlign: 'center',
    color: mainColor.secondaryColor
  },
  produits: {
    fontSize: UNIT * 0.9375,
    minWidth: UNIT * 9,
    maxWidth: UNIT * 20,
    padding: UNIT * 1.0625,
    wordBreak: 'break-all'
  },
  lastRow: {
    fontSize: UNIT * 0.9375,
    minWidth: UNIT * 5
  },
  heading: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight
  },
  typo: {
    fontSize: UNIT * 0.875
  },
  root: {
    width: '100%',
    overflowX: 'auto',
    paddingTop: '5px'
  },
  table: {
    minWidth: 700
  },
  labelStyle: {
    alignSelf: 'center',
    fontSize: UNIT
  },
  grid: { justifyContent: 'flex-end', display: 'flex', fontSize: UNIT, padding: 5 },
  svg: { padding: UNIT * 0.625 },
  disabledButton: {
    backgroundColor: '#a7a3a3!important',
    borderColor: '#a7a3a3!important',
    opacity: 'inherit!important',
  },
  paperStyle: {
    border: '2px solid #B7B7B7',
    right: -UNIT * 1.8125
  },
  buttonStyle: {
    backgroundColor: '#a7a3a3!important',
    borderColor: '#a7a3a3!important',
    float: 'right',
    top: -UNIT * 3,
    opacity: 'inherit!important',
  },
  emptyStyle: {
    top: UNIT * -2.9375
  },
  disabledSvg: { padding: UNIT * 0.625, color: '#858383' },
  disabledButtonStyle: {
    padding: '0px 63px',
    border: '1px solid white',
    marginTop: -UNIT * 1.625,
    marginRight: UNIT,
    float: 'right'
  }

});
